import styled, { css } from 'styled-components';

import { color, media } from 'app/shared/styles_js/variables';

const experimentZindex = {
  cookieBanner: 1070,
  cookieBannerOverlay: 1060,
};

export const CookieBannerContainerSt = styled.div`
  position: fixed;
  z-index: ${experimentZindex.cookieBanner};
  right: 15px;
  bottom: 15px;
  left: 15px;

  ${media.md(css`
    right: auto;
    max-width: 400px;
  `)};
`;

export const CookieBannerContentSt = styled.div`
  padding: 15px;
  border-radius: 4px;
  font-size: 13px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
  background-color: ${color.grayLightest};
`;

export const CookieBannerTextWrapperSt = styled.div`
  margin-bottom: 15px;
  font-size: 10px;
  line-height: 1.6;
`;

export const CookieBannerCallToActionSt = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const CookieBannerCallToActionItemSt = styled.div`
  flex-basis: 50%;
  text-align: center;
  font-weight: bold;
`;

export const CookieBannerOverlaySt = styled.div`
  position: fixed;
  z-index: ${experimentZindex.cookieBannerOverlay};
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0.8;
  background-color: ${color.black};
`;
